import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RoutingService, User } from '@spartacus/core';
import { filter, map } from 'rxjs/operators';
import {
  CustomOrderHistory
} from '../../../custom-order-history.models';
import {UserAccountFacade} from '@spartacus/user/account/root';

@Component({
    selector: 'app-custom-order-history-overview-table-default',
    templateUrl: './custom-order-history-overview-table-default.component.html',
    standalone: false
})
export class CustomOrderHistoryOverviewTableDefaultComponent implements OnInit {
  @Input() orders: CustomOrderHistory[];
  @Output() cancelOrder: EventEmitter<string> = new EventEmitter<string>();
  CAN_EDIT = 'edit_order_history';
  canEdit = false;
  constructor(
    protected routing: RoutingService,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.userAccountFacade
      .get()
      .pipe(filter((user: User) => user && Object.keys(user).length > 0))
      .subscribe((user) => {
        const hasRole = user.roles && user.roles.includes(this.CAN_EDIT);
        if (hasRole) {
          this.canEdit = true;
        }
      });
  }

  onCancelOrder(event: any, uigOrderNumber: string) {
    event.stopPropagation();
    this.cancelOrder.emit(uigOrderNumber);
  }

  goToOrderDetail(order: CustomOrderHistory): void {
    this.routing.go({
      cxRoute: 'orderDetails',
      params: order,
    });
  }
}
